module.exports = __webpack_public_path__ + "static/img/promo_order_3.dcb5d37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promo_order_3.jpg
// module id = 35xm
// module chunks = 0